import { uniq } from 'lodash';
import { Seat, SeatZone, SeatPricing, CartSeat } from '../../classes/seat';
import { PriceType } from '../../classes/price-type';
import * as isEqual from 'react-fast-compare';

import { IPriceRangeModel } from '../../filter/reducers/filter-reducers';

import SeatPath from './seat-path';
import SeatGroupPath from './seat-group-path';
import * as React from 'react';

interface ISeatPaths {
    seats: Array<Seat>;
    selectedSeats: Array<Seat>;
    dispatch: any;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    cartSeats: Array<CartSeat>;
    priceRangeModel: IPriceRangeModel;
    mapDragging: boolean;
    isExchange: boolean;

    hoveredSeatId: string;
    mouseOverSeat: (seats: Array<Seat>, xPos: number, yPos: number) => void;
    mouseOutSeat: () => void;
    isChrome: boolean;
}

class SeatPaths extends React.Component<ISeatPaths, any> {
    private singleSeats: Array<Seat>;
    private seatsWithSamePaths: Array<Seat>;
    private seatGroupIds: Array<string>;

    constructor(props) {
        super(props);
        let seatWithPaths = props.seats.filter(seat => {
            return seat.svgPath !== null;
        });

        this.seatsWithSamePaths = seatWithPaths.filter(seat => {
            return seatWithPaths.filter(s => s.svgPathId === seat.svgPathId).length > 1;
        });

        this.seatGroupIds = uniq(this.seatsWithSamePaths.map(path => path.svgPathId));
        if (this.props.isChrome) {
            this.seatGroupIds = this.seatGroupIds.reverse();
        }

        this.singleSeats = seatWithPaths.filter(seat => {
            return seatWithPaths.filter(s => s.svgPathId === seat.svgPathId).length == 1;
        });
    }

    shouldComponentUpdate(nextProps: ISeatPaths, nextState) {
        return this.props.priceRangeModel.minPrice !== nextProps.priceRangeModel.minPrice
            || ((this.props.selectedSeats.length == 0) ? (nextProps.selectedSeats.length > 0 ? true : false)
                : this.props.selectedSeats[0].seatId !== nextProps.selectedSeats[0].seatId)
            || !isEqual(this.props, nextProps);
    }

    render() {
        return <g>
            {
                this.singleSeats.map(seat => {
                    return <SeatPath dispatch={this.props.dispatch}
                        seat={seat}
                        key={seat.seatId}
                        selectedSeat={this.props.selectedSeats.length > 0 ? this.props.selectedSeats[0] : null}
                        levelPricing={this.props.levelPricing}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        lowerPrice={this.props.priceRangeModel.minPrice}
                        upperPrice={this.props.priceRangeModel.maxPrice}
                        mouseOutSeat={this.props.mouseOutSeat}
                        mouseOverSeat={this.props.mouseOverSeat}
                        mapDragging={this.props.mapDragging}
                        cartSeats={this.props.cartSeats}
                        seatHovered={this.props.hoveredSeatId === seat.seatId}
                    />
                })
            }
            {
                this.seatGroupIds.map((svgPathId) => {
                    var groupSeats = this.seatsWithSamePaths.filter(seat => seat.svgPathId === svgPathId);
                    var sortedSeats = [...groupSeats].sort((a, b) => {
                        return (b.tessituraSeat.isAvailable ? 1 : 0) - (a.tessituraSeat.isAvailable ? 1 : 0);
                    });
                    return <SeatGroupPath dispatch={this.props.dispatch}
                        seats={sortedSeats}
                        key={svgPathId}
                        cartSeats={this.props.cartSeats}
                        selectedSeats={this.props.selectedSeats}
                        levelPricing={this.props.levelPricing}
                        selectedPriceTypes={this.props.selectedPriceTypes}
                        lowerPrice={this.props.priceRangeModel.minPrice}
                        upperPrice={this.props.priceRangeModel.maxPrice}
                        isExchange={this.props.isExchange}
                        mouseOutGroup={this.props.mouseOutSeat}
                        mouseOverGroup={this.props.mouseOverSeat}
                        mapDragging={this.props.mapDragging}
                    />
                })
            }

        </g>
    }

    computeSeatHoverPositionY(seat: Seat) {
        var pos = document.getElementById('seat-' + seat.seatId).getBoundingClientRect();
        var yPos = window.innerHeight / 2 - pos.bottom - pos.height;

        if (yPos > 0) {
            yPos = yPos + (pos.height);
        }

        return yPos;
    }

    computeSeatHoverPositionX(seat: Seat) {
        var pos = document.getElementById('seat-' + seat.seatId).getBoundingClientRect();

        return pos.left + (pos.width / 2);
    }
}

export default SeatPaths;